import { useCallback } from 'react';
import { TABLE_KEY } from './Cmarkdowntable.constants';
import type {
  OpenTablePopoverRowInput,
  TableRowKeyDownInput,
} from './Cmarkdowntable.types';

interface UseCmarkdowntablePopoverKeyboardInput {
  openPopoverForRow: (input: OpenTablePopoverRowInput) => void;
}

export function useCmarkdowntablePopoverKeyboard(
  input: UseCmarkdowntablePopoverKeyboardInput,
): (input: TableRowKeyDownInput) => void {
  const { openPopoverForRow } = input;

  return useCallback((keyInput: TableRowKeyDownInput): void => {
    if (keyInput.event.key !== TABLE_KEY.Enter && keyInput.event.key !== ' ') {
      return;
    }

    keyInput.event.preventDefault();
    openPopoverForRow({
      rowIndex: keyInput.rowIndex,
      row: keyInput.row,
      anchorElement: keyInput.anchorElement,
    });
  }, [openPopoverForRow]);
}
